import { render } from "./batterySwapping.vue?vue&type=template&id=dd005fea&scoped=true"
import script from "./batterySwapping.vue?vue&type=script&lang=js"
export * from "./batterySwapping.vue?vue&type=script&lang=js"

import "./batterySwapping.vue?vue&type=style&index=0&id=dd005fea&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd005fea"]])

export default __exports__